import { createReducer, on, Action } from '@ngrx/store';
import * as deliveriesActions from '../actions/deliveries.actions';
import { DeliveriesResponseModel } from 'app/models/delivery-api.model';
import { AssignmentModel } from 'app/models/assignment-api.model';

export interface State {
  deliveries: DeliveriesResponseModel;
  isLoading: boolean;
  isReady: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  deliveries: { results: [], count: 0 },
  isLoading: false,
  isReady: false,
  isSaving: false,
};

export const featureReducer = createReducer(
  initialState,
  on(
    deliveriesActions.loadDeliveries,
    deliveriesActions.loadDelivery,
    (state: State) => ({
      ...state,
      isLoading: true,
      isReady: false,
    })
  ),
  on(deliveriesActions.loadDeliveriesSuccess, (state: State, { response }) => ({
    ...state,
    isLoading: false,
    isReady: true,
    deliveries: response,
  })),
  on(deliveriesActions.loadDeliverySuccess, (state: State, { delivery }) => ({
    ...state,
    isLoading: false,
    isReady: true,
  })),
  on(
    deliveriesActions.createDelivery,
    deliveriesActions.updateDelivery,
    (state) => ({
      ...state,
      isSaving: true,
    })
  ),
  on(
    deliveriesActions.createDeliverySuccess,
    deliveriesActions.createDeliveryFailed,
    deliveriesActions.updateDeliverySuccess,
    deliveriesActions.updateDeliveryFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
